import React from 'react'
import Form from 'react-bootstrap/Form';

const ThemeTextarea = ({labelName,requiredStar,onChange,value,name}) => {
  return (
    <>
        <Form.Label>{labelName}<span className='redStar'>{requiredStar}</span></Form.Label>
        <Form.Control as="textarea" rows={3}
        onChange ={onChange}
        value={value}
        name={name} />
    </>
  )
}

export default ThemeTextarea

// import React from 'react'
// import Form from 'react-bootstrap/Form';

// const ThemeTextarea = ({labelName,requiredStar,onChange,value,name}) => {
//   return (
//     <>
//         <Form.Label>{labelName}<span className='redStar'>{requiredStar}</span></Form.Label>
//         <Form.Control as="textarea" rows={3}
//         onChange ={onChange}
//         value={value}
//         name={name} />
//     </>
//   )
// }
// export default ThemeTextarea

// import React from 'react';
// import Form from 'react-bootstrap/Form';
// import { sanitizeInput } from '../constants/commonFunction';

// const ThemeTextarea = ({ labelName, requiredStar, onChange, value, name }) => {
  // const sanitizeInput = (input) => {

    
  //   return DOMPurify.sanitize(input, { 
  //     ALLOWED_TAGS: [],       
  //     ALLOWED_ATTR: [],
  //     KEEP_CONTENT: true       
  //   });
  // };

//   const handleChange = (e) => {
//     const rawValue = e.target.value;
//     const cleanValue = rawValue.replace(/[<>/:;={}@#!!$^&*()_+~\|`-]/g, '');
//     const sanitizedValue = sanitizeInput(cleanValue);

//     e.target.value = cleanValue;
//     onChange(e);
//   };

//   return (
//     <>
//       <Form.Label>
//         {labelName}
//         <span className="redStar">{requiredStar}</span>
//       </Form.Label>
//       <Form.Control
//         as="textarea"
//         rows={3}
//         onChange={handleChange}
//         value={value}  
//         name={name}
//       />
//     </>
//   );
// };

// export default ThemeTextarea;